import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "compass",
  "use": "compass-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" class=\"feather feather-compass\" viewBox=\"0 0 24 24\" id=\"compass\"><circle cx=\"12\" cy=\"12\" r=\"10\" /><path d=\"M16.24 7.76l-2.12 6.36-6.36 2.12 2.12-6.36 6.36-2.12z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol